<script lang="ts">
	import type { FuelPrices } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as c from '$lib/i18n/computedMessages';
	import { getLanguageCode } from '$lib/i18n/language';
	import { formatPastTime } from '$lib/utils/date';
	import PoiSummaryTemplate from '../PoiSummaryTemplate.svelte';

	interface Props {
		name: string;
		fuelPrices?: FuelPrices;
		lastUpdated?: Date;
		onAddClick?: () => void;
	}

	const {
		name,
		fuelPrices = undefined,
		lastUpdated = undefined,
		onAddClick,
	}: Props = $props();

	const color = 'energy';
</script>

<PoiSummaryTemplate {name} {color}>
	{#snippet infos()}
		<div class="gridcontainer w-full mt-2">
			{#if fuelPrices}
				{#each fuelPrices as { type, price } (`${type}-${price.amount}`)}
					<div class="flex flex-col">
						<div class="truncate text-bold">
							{c.gasStationFuel(type)}
						</div>
						<div>{price.amount}</div>
					</div>
				{/each}
			{/if}
		</div>
	{/snippet}
	{#snippet buttons()}
		<ButtonAddToItinerary
			size="sm"
			onclick={onAddClick}
		/>
	{/snippet}
	{#snippet note()}
		{#if lastUpdated}
			{@const [timeText, relativeFlag] = formatPastTime(lastUpdated, getLanguageCode())}
			<div class="flex items-center gap-0.5 text-sm text-neutral truncate">
				{#if relativeFlag}
					<Icon icon="autorenew" />
				{/if}
				{timeText}
			</div>
		{/if}
	{/snippet}
</PoiSummaryTemplate>

<style>
	.gridcontainer {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 36px;
		gap: 8px;
	}
</style>
